import React from "react";
import {
  TouchableOpacity,
  TouchableWithoutFeedback,
  StyleSheet,
  Text,
  SafeAreaView,
  KeyboardAvoidingView,
  View,
  TextInput,
  Platform,
  Linking
} from "react-native";
import { Auth } from "aws-amplify";
import { useNavigation } from "@react-navigation/native";
import UnderLine from "../AnimatedUnderLine";
import GenericButton from "../GenericButton";

export default function ForgotPassword(props) {
  const autofill = props.autofill || "";
  const [username, onChangeUserText] = React.useState(autofill);
  const [password, onChangePassText] = React.useState("");
  const [authCode, onChangeAuthCodeText] = React.useState("");

  const [step, onChangeStep] = React.useState(0);

  const [errorMsg, onErrorMsg] = React.useState("");

  const navigation = useNavigation();

  const tryResetPassword = async (username) => {
    if (username === "") {
      onErrorMsg("Please enter Email");
    } else {
      try {
        const res = await Auth.forgotPassword(username);
        onChangeStep(1);
      } catch (error) {
        onErrorMsg(error.message);
      }
    }
  };

  const forgotPasswordSubmit = async (username, password, authCode) => {
    if (password === "") {
      onErrorMsg("Please enter New Password");
    } else if (authCode === "") {
      onErrorMsg("Please enter Authcode");
    } else {
      try {
        await Auth.forgotPasswordSubmit(username, authCode, password);
        navigation.navigate("Login");
      } catch (error) {
        onErrorMsg(error.message);
      }
    }
  };

  return (
    <SafeAreaView style={styles.container}>
      <KeyboardAvoidingView style={styles.container} behavior="padding" enabled>
        {step === 0 ? (
          <View style={styles.container}>
            <View style={styles.infoBox}>
              <View style={styles.inputContainer}>
                <TextInput
                  style={styles.textInput}
                  placeholder="Email"
                  placeholderTextColor="#adb4bc"
                  value={username}
                  onChangeText={(text) => onChangeUserText(text)}
                />
              </View>
              <Text style={styles.TextStyleError}>{errorMsg}</Text>
            </View>
            {/* This commented section can be removed in 7/11/2023  */}
            {/* <TouchableOpacity
            style={styles.SubmitButtonStyle}
            onPress={() => {
              tryResetPassword(username);
            }}
          >
            <Text style={styles.TextStyleBlack}>EMAIL RESET CODE</Text>
          </TouchableOpacity> */}
            <GenericButton
              buttonText='EMAIL RESET CODE'
              onPress={() => {
                tryResetPassword(username);
              }}
            />
            <Text style={[styles.TextStyleLink, { fontFamily: 'montserrat-medium' }]}>Forgot your login? Enter the email you registered with to receive a reset code.</Text>
            <Text style={[styles.TextStyleLink, { fontFamily: 'montserrat-medium' }]}>
              Or contact our&nbsp;
              <Text style={styles.TextStyleLinkLink}
                onPress={() => {
                  Platform.OS !== "web"
                    ? Linking.openURL("https://aura.club/contact/")
                    : window.open("https://aura.club/contact/", "_blank");
                }}>support team.
              </Text>
            </Text>
          </View>
        ) : (<></>)}
        {step === 1 ? (
          <View style={styles.container}>
            <View style={styles.infoBox}>
              <View style={styles.inputContainer}>
                <TextInput
                  style={styles.textInput}
                  placeholder="Confirmation code"
                  placeholderTextColor="#adb4bc"
                  keyboardType={"numeric"}
                  returnKeyType="done"
                  autoCapitalize="none"
                  autoCorrect={false}
                  secureTextEntry={false}
                  value={authCode}
                  onChangeText={(text) => onChangeAuthCodeText(text)}
                />
              </View>
              {/*  password section  */}
              <View style={styles.inputContainer}>
                <TextInput
                  style={styles.textInput}
                  placeholder="New Password"
                  placeholderTextColor="#adb4bc"
                  returnKeyType="next"
                  autoCapitalize="none"
                  autoCorrect={false}
                  secureTextEntry={true}
                  value={password}
                  onChangeText={(text) => onChangePassText(text)}
                />
                <Text style={styles.TextStylePassword}>At least 8 Characters.</Text>
                <Text style={styles.TextStylePassword}>(With 1 letter and 1 number.)</Text>
                <Text style={styles.TextStyleError}>{errorMsg}</Text>
              </View>
            </View>
            <TouchableOpacity
              style={styles.SubmitButtonStyle}
              onPress={() => {
                forgotPasswordSubmit(username, password, authCode);
              }}
            >
              <Text style={styles.TextStyle}>CHANGE PASSWORD</Text>
            </TouchableOpacity>
          </View>
        ) : (
          <></>
        )}
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    width: 350,
    alignSelf: "center",
  },
  infoBox: {
    backgroundColor: "#ffffff",
    borderRadius: 15,
    marginBottom: 20,
    padding: 20,
  },
  buttonStyle: {
    alignItems: "center",
    backgroundColor: "#b44666",
    padding: 14,
    marginBottom: 10,
    borderRadius: 3,
  },
  TextStyleLink: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    paddingTop: 10,
    lineHeight: 25
  },
  TextStyleLinkLink: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-medium",
    fontSize: 14,
    paddingTop: 10,
    lineHeight: 25,
    textDecorationLine: "underline",
  },
  xxxtextStyle: {
    padding: 5,
    fontSize: 14,
    color: "#fff",
    fontWeight: "bold",
  },
  inputContainer: {
    paddingTop: 15,
  },
  textInput: {
    ...Platform.select({
      web: {
        outlineStyle: 'none'
      }
    }),
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
    height: 40,
    fontSize: 16,
    paddingRight: 20,
    fontFamily: "montserrat-regular",
  },
  TextStyle: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
  },
  TextStyleBlack: {
    color: "#000000",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
  },
  SubmitButtonStyle: {
    marginBottom: 30,
    paddingTop: 15,
    paddingBottom: 15,
    backgroundColor: "#FFC40C",
    borderRadius: 30,
  },
  TextStyleError: {
    color: "#000000",
    textAlign: "center",
    fontFamily: "montserrat-regular",
    fontSize: 10,
    paddingTop: 10,
  },
  TextStylePassword: {
    color: "#000000",
    textAlign: "center",
    fontFamily: "montserrat-regular",
    fontSize: 10,
    paddingTop: 3,
  },
});
